import { Helmet } from 'react-helmet-async';
import { useLanguage } from '../i18n';

export default function PrivacyPolicy() {
  const { t } = useLanguage();
  const tt = (k: string) => t('privacyPolicy', k);
  const title = tt('title');

  return (
    <article className="cookie-policy-page">
      <Helmet>
        <title>{title} — RetroGameUp</title>
      </Helmet>
      <h1>{title}</h1>
      <p className="cookie-policy-updated">{tt('lastUpdated')}</p>
      <p className="cookie-policy-intro">{tt('intro')}</p>

      <section>
        <h2>{tt('emailTitle')}</h2>
        <p>{tt('emailBody')}</p>
      </section>

      <section>
        <h2>{tt('externalLinksTitle')}</h2>
        <p>{tt('externalLinksBody')}</p>
      </section>

      <section>
        <h2>{tt('analyticsTitle')}</h2>
        <p>{tt('analyticsBody')}</p>
      </section>

      <section>
        <h2>{tt('advertisingTitle')}</h2>
        <p>{tt('advertisingBody')}</p>
      </section>

      <section>
        <h2>{tt('contactTitle')}</h2>
        <p>{tt('contactBody')}</p>
      </section>
    </article>
  );
}
